var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelopeOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 796,
    height: 814,
    viewBox: "0 0 796 814",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1347_9820)",
    filter: "url(#filter0_d_1347_9820)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.375,
    y: 313.688,
    width: 755.25,
    height: 478.25,
    rx: 7.625,
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1347_9820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M768 312.813H28C23.5817 312.813 20 309.231 20 304.813V282.813L377.466 34.5729C389.813 25.9986 406.187 25.9986 418.534 34.5729L776 282.813V304.813C776 309.231 772.418 312.813 768 312.813Z",
    fill: "#FF5F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 312.813H28C23.5817 312.813 20 309.231 20 304.813V282.813L377.466 34.5729C389.813 25.9986 406.187 25.9986 418.534 34.5729L776 282.813V304.813C776 309.231 772.418 312.813 768 312.813Z",
    stroke: "#FF5F3D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1347_9820)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 93.313,
    width: 716,
    height: 678,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M776 343.313L473.6 553.313L776 763.313V343.313ZM20 785.333V763.313L322.4 553.313L20 343.313V785.313C20 785.32 20 785.326 20 785.333Z",
    fill: "#FF5F3D"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1347_9820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M768 792.813H28C23.5817 792.813 20 789.231 20 784.813V762.813L377.466 514.573C389.813 505.999 406.187 505.999 418.534 514.573L776 762.813V784.813C776 789.231 772.418 792.813 768 792.813Z",
    fill: "#FF5F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 792.813H28C23.5817 792.813 20 789.231 20 784.813V762.813L377.466 514.573C389.813 505.999 406.187 505.999 418.534 514.573L776 762.813V784.813C776 789.231 772.418 792.813 768 792.813Z",
    stroke: "#FF5F3D"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 397.534,
    cy: 572.847,
    r: 40.5337,
    fill: "white",
    stroke: "#66CDAA",
    strokeWidth: 1.65444
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.607 573.966L393.457 579.815",
    stroke: "#66CDAA",
    strokeWidth: 2.48165,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.934 579.464L407.996 565.401",
    stroke: "#66CDAA",
    strokeWidth: 2.48165,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1347_9820",
    x: 0,
    y: 0.312988,
    width: 796,
    height: 813,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0 0.509804 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1347_9820"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1347_9820",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1347_9820",
    x: -10.5,
    y: 7.64209,
    width: 817,
    height: 345.671,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0 0.509804 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1347_9820"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1347_9820",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1347_9820",
    x: 16,
    y: 73.313,
    width: 764,
    height: 726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0 0.509804 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1347_9820"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1347_9820",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1347_9820",
    x: 9.5,
    y: 492.642,
    width: 777,
    height: 305.671,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.407843 0 0 0 0 0.45098 0 0 0 0 0.509804 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1347_9820"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1347_9820",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1347_9820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 756,
    height: 773,
    fill: "white",
    transform: "translate(20 20.313)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeOpen);
export default __webpack_public_path__ + "static/media/envelope-open.9124fef138898b975de744a787bd104e.svg";
export { ForwardRef as ReactComponent };